import { configureStore } from "@reduxjs/toolkit";
import { apiSlice } from "./api/apiSlice";
import { setupListeners } from "@reduxjs/toolkit/query";
import authReducer from "../features/auth/authSlice";
import userReducer from "../features/users/userSlice";
import { fieldHelpAiSlice } from "../features/fieldHelp/fieldHelpAiSlice";
import { formSuggestionApiSlice } from "../features/formSuggestion/formSuggestionApiSlice";

// Load state from localStorage if available
const loadState = () => {
  try {
    const serializedState = localStorage.getItem('reduxState');
    if (serializedState === null) {
      return undefined;
    }
    return JSON.parse(serializedState);
  } catch (err) {
    console.error('Error loading state from localStorage:', err);
    return undefined;
  }
};

// Save state to localStorage
const saveState = (state) => {
  try {
    // Only save the auth portion of the state to avoid storing too much data
    const serializedState = JSON.stringify({
      auth: state.auth
    });
    localStorage.setItem('reduxState', serializedState);
  } catch (err) {
    console.error('Error saving state to localStorage:', err);
  }
};

const persistedState = loadState();

export const store = configureStore({
  reducer: {
    [apiSlice.reducerPath]: apiSlice.reducer,
    [fieldHelpAiSlice.reducerPath]: fieldHelpAiSlice.reducer,
    [formSuggestionApiSlice.reducerPath]: formSuggestionApiSlice.reducer,
    auth: authReducer,
    user: userReducer,
  },
  preloadedState: persistedState,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      apiSlice.middleware,
      fieldHelpAiSlice.middleware,
      formSuggestionApiSlice.middleware
    ),
  devTools: true,
});

// Subscribe to store changes to save state
store.subscribe(() => {
  saveState(store.getState());
});

setupListeners(store.dispatch);